import { SQLService } from '../../../services/sql.service';
import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ng-cheques-design-menu',
  templateUrl: './design-menu.component.html',
  styleUrls: ['./design-menu.component.styl']
})
export class DesignMenuComponent implements OnInit {
  constructor(
    public sql: SQLService,
    public popover: PopoverController,
    private router: Router) {
  }
  list:string;
  dismissPopover(e) {
    if (this.popover) this.popover.dismiss(e);
  }

  ngOnInit() {
  }
}